/**
 * What useLoad() says for a 404 `capability_disabled` (PM gaps B1, 2026-11-01): the function is off, not broken.
 * LoadError knows this sentence and offers no «Prøv igjen». Its own module with no imports, so components/ui.tsx can
 * read it without pulling in the API client.
 */
export const CAPABILITY_OFF_NO = 'Denne funksjonen er slått av for moskeen.';
